import { Box, Flex, Text, useDisclosure } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import QrButton from "./QrButton";
import QrDrawer from "./QrDrawer";
import { getOrder, Order, Status } from "@/api/order";
import { accAdd, formatAmountWithFixed } from "@/utils/formatBalance";
import { usdcInfo } from "@/constants/tokens";
import TitleHeader from "@/components/TitleHeader";
import { useUserInfo } from "@/context/UserInfo";
import { useCurrencyExchange } from "@/hooks/useCurrencyExchange";
const ChargeDetail = () => {
  const navigate = useNavigate();
  const { showUsd } = useUserInfo();
  const { usdToCurrency, currencyUnit } = useCurrencyExchange();
  const {
    isOpen: isQrOpen,
    onOpen: onQrOpen,
    onClose: onQrClose,
  } = useDisclosure();
  const { orderId } = useParams();
  const [orderDetail, setOrderDetail] = useState<Order | null>(null);

  const handelOnClose = () => {
    onQrClose();
  };

  const getOrderDetail = async () => {
    try {
      const order = await getOrder(orderId!);
      setOrderDetail(order);
      console.log(order);
      if (order.status === Status.Completed) {
        navigate(`/receipt/${order.id}`);
      }
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    if (!orderId) return;
    getOrderDetail();
    const timer = setInterval(async () => {
      getOrderDetail();
    }, 3000);
    return () => {
      clearInterval(timer);
    };
  }, [orderId]);

  return (
    <Flex
      flexDir={"column"}
      align={"center"}
      sx={{
        padding: "20px 20px 100px",
      }}
    >
      <TitleHeader
        color="#D8762B"
        onBack={() => navigate(-1)}
        title="Charge"
        showSwitch={true}
      />
      <Flex
        sx={{
          width: "100%",
          marginTop: "30px",
        }}
        align={"center"}
        justify={"space-between"}
      >
        <Text
          sx={{
            color: "#848484",
            textAlign: "center",
            fontSize: "16px",
            fontWeight: 900,
            fontFamily: "DIN-Black",
          }}
        >
          Subtotal:
        </Text>
        <Box sx={{ textAlign: "right" }}>
          <Text
            sx={{
              color: "#333",
              fontWeight: 500,
            }}
          >
            <span
              style={{
                fontFamily: "DIN-Black",
                fontSize: "20px",
              }}
            >
              {formatAmountWithFixed(
                usdToCurrency(orderDetail?.orderAmount),
                usdcInfo.decimals
              )}{" "}
            </span>
            <span style={{ fontSize: "16px", fontWeight: 700 }}>
              {currencyUnit}
            </span>
          </Text>
          {!showUsd && (
            <Text>
              {" "}
              <span
                style={{
                  fontSize: "12px",
                }}
              >
                {formatAmountWithFixed(
                  orderDetail?.orderAmount,
                  usdcInfo.decimals
                )}{" "}
              </span>
              <span style={{ fontSize: "12px", fontWeight: 700 }}>USD</span>
            </Text>
          )}
        </Box>
      </Flex>
      <Flex
        sx={{
          width: "100%",
          marginTop: "30px",
        }}
        align={"center"}
        justify={"space-between"}
      >
        <Text
          sx={{
            color: "#848484",
            textAlign: "center",
            fontSize: "16px",
            fontWeight: 900,
            fontFamily: "DIN-Black",
          }}
        >
          Tax:
        </Text>
        <Box
          sx={{
            textAlign: "right",
          }}
        >
          <Text
            sx={{
              color: "#333",
              fontWeight: 500,
            }}
          >
            <span
              style={{
                fontSize: "20px",
                fontFamily: "DIN-Black",
              }}
            >
              {formatAmountWithFixed(
                usdToCurrency(orderDetail?.taxAmount),
                usdcInfo.decimals
              )}{" "}
            </span>{" "}
            <span style={{ fontSize: "16px", fontWeight: 700 }}>
              {currencyUnit}
            </span>
          </Text>

          <Text>
            {!showUsd && (
              <span
                style={{
                  fontSize: "12px",
                }}
              >
                {formatAmountWithFixed(
                  orderDetail?.taxAmount,
                  usdcInfo.decimals
                )}{" "}
                USD{" "}
              </span>
            )}
            <span style={{ fontSize: "12px" }}>({orderDetail?.taxRate}%)</span>
          </Text>
        </Box>
      </Flex>
      <Flex
        sx={{
          width: "100%",
          marginTop: "30px",
        }}
        align={"center"}
        justify={"space-between"}
      >
        <Text
          sx={{
            color: "#848484",
            textAlign: "center",
            fontSize: "16px",
            fontWeight: 900,
            fontFamily: "DIN-Black",
          }}
        >
          Total:
        </Text>
        <Box sx={{ textAlign: "right" }}>
          <Text
            sx={{
              color: "#333",
              fontWeight: 700,
            }}
          >
            <span
              style={{
                fontFamily: "DIN-Black",
                fontSize: "30px",
              }}
            >
              {formatAmountWithFixed(
                usdToCurrency(
                  accAdd(orderDetail?.orderAmount, orderDetail?.taxAmount)
                ),
                usdcInfo.decimals
              )}{" "}
            </span>{" "}
            <span
              style={{
                fontSize: "16px",
                fontWeight: 700,
              }}
            >
              {currencyUnit}
            </span>
          </Text>
          {!showUsd && (
            <Text>
              <span style={{ fontSize: "12px" }}>
                {formatAmountWithFixed(
                  accAdd(orderDetail?.orderAmount, orderDetail?.taxAmount),
                  usdcInfo.decimals
                )}{" "}
              </span>
              <span style={{ fontSize: "12px" }}>USD</span>
            </Text>
          )}
        </Box>
      </Flex>
      <QrButton onClick={onQrOpen}></QrButton>
      <QrDrawer
        isOpen={isQrOpen}
        onClose={handelOnClose}
        orderId={orderId}
      ></QrDrawer>
    </Flex>
  );
};

export default ChargeDetail;
